<template>
    <div class="home">
      <div class="container">
        <div class="columns is-centered">
          <div class="column">
            <div class="content">
              <ValidationObserver
          v-slot="{ errors }"
          tag="div"
        >
          <input-form
            ref="form"
            :errors="errors"
            name="LandlordApplicationFrm"
            @submit.prevent="handleSubmit"
          >
            <h1>Check Your Application Status</h1>
            <callout
              type="info"
            >
              Please enter your Application ID.
            </callout>
            <textbox
              v-model.trim="ApplicationId"
              name="txt-application-id"
              placeholder="Application ID:"
              @keydown.enter.prevent=""
            />
            <div class="column is-2 is-offset-10">
              <button
                type="button"
                :disabled="[SubmitStatus.Options.PENDING].includes(SubmitStatus)"
                class="button is-primary"
                @click="handleSubmit"
              >
                Check Status
              </button>
            </div>
            <div
              v-if="SubmitStatus.Value === SubmitStatus.Options.OK"
              class="cell"
            >
              <!-- <label for="status-check-result-list">EDP Application Status</label>
              <ul
                v-if="StatusCheckResult"
                id="status-check-result-list"
                name="status-check-result-list"
              >
                <li
                  v-for="(result, idx) in StatusCheckResult"
                  :key="idx"
                > -->
              <div v-html="StatusCheckResult" />
              <!-- </li> -->
            </div>
            <div v-else-if="SubmitStatus.Value === SubmitStatus.Options.PENDING">
              Loading...
            </div>
            <div v-else-if="SubmitStatus.Value === SubmitStatus.Options.ERROR">
              <callout
                message="An application with that ID cannot be found, please ensure you have the correct application ID and try again."
                type="danger"
              />
            </div>
            <br>
          </input-form>
        </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import options from "@/utilities/options";
import axios from "axios";
import buildStatusCheckDataObject from "@/utilities/data-objects/status-check-data-object";
import {
  getPropertyValueOrDefault,
} from "@/utilities/functions";

export default {
  name: "StatusPage",
  mixins: [options],
  data() {
    return {
      StatusCheckResult: null,
      ApplicationId: null,
    };
  },
  methods: {
    async handleSubmit() {
      var vData = this;
      vData.SubmitStatus.Value = vData.SubmitStatus.Options.PENDING;
      const dataObject = buildStatusCheckDataObject(
        vData.ApplicationId,
        "COMMON_APP_GET_STATUS",
      );
      const requestObj = {
        data: dataObject,
      };
      axios
        .post(
          "https://api.phdcphila.org/common-app/check-status",
          requestObj,
        )
        .then(qbResult => {
          vData.SubmitStatus.Value = vData.SubmitStatus.Options.OK;
          const singleReturnValue = getPropertyValueOrDefault(
            ["data", "record", "f", "_text"],
            qbResult,
          );
          if(singleReturnValue != null){
            vData.StatusCheckResult = singleReturnValue;
          }else{
            vData.StatusCheckResult = "Record Not Found";
          }
          // const multipleReturnValue = getPropertyValueOrDefault(
          //   ["data", "record", "f"],
          //   qbResult,
          // );
          // if (singleReturnValue) {
          //   let cleanReturnValue = singleReturnValue.replace(
          //     /(\\r)*\\n/g,
          //     "<br>",
          //   );
          //   const isAnchor = /<a[^>]*>([^<]+)<\/a>/g.test(singleReturnValue);
          //   if (!isAnchor) {
          //     cleanReturnValue = toAnchorTag(cleanReturnValue);
          //   }
          //   vData.StatusCheckResult = cleanReturnValue.split(";");
          // } else if (multipleReturnValue) {
          //   // do something with multiple values...
          //   vData.StatusCheckResult = multipleReturnValue.map(i => i._text);
          // } else {
          //   vData.SubmitStatus.Value = vData.SubmitStatus.Options.NOT_FOUND;
          // }
        }).catch(function(error) {
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
            vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
          }
          vData.statusResult = "Request Timed Out. Please Try Again.";
        });
    },
  },
};
</script>